module.exports = __webpack_public_path__ + "static/media/binit-illustration-high-five.41d6b920.svg";